let navigation = {
    init() {
        this.templates = {
            level1_nosubmenu: document.getElementById('MobileMenuItem_Level1_NoSubmenu_Template'),
            level1_submenu: document.getElementById('MobileMenuItem_Level1_Submenu_Template'),
            plain: document.getElementById('MobileMenuItem_Plain_Template')
        };
        
        this.target = document.getElementById('MobileMenu');

        this.getData().then(data => {
            if (data != null && data.links != null) {
                let code = '';

                for (const item of data.links) {
                    if (item.links == null) {
                        code += this.populate(this.templates.level1_nosubmenu.innerHTML, item);
                    } else {
                        let subItem = document.createElement('div');
                        subItem.innerHTML = this.populate(this.templates.level1_submenu.innerHTML, item);

                        let childrenCode = '';
                        childrenCode += '<li><h4 class="frame_title"></h4></li>';

                        for (const child of item.links) {
                            if (child.links == null) {
                                childrenCode += this.populate(this.templates.plain.innerHTML, child);
                            } else {
                                let subItem = document.createElement('div');
                                subItem.innerHTML = this.populate(this.templates.level2_submenu.innerHTML, item);

                                let grandchildrenCode = '';
                                grandchildrenCode += '<li><h4 class="frame_title"></h4></li>';

                                for (const grandchild of child.links) {
                                    grandchildrenCode += this.populate(this.templates.plain.innerHTML, grandchild);
                                }

                                subItem.querySelector('ul').innerHTML = grandchildrenCode;
                            }
                        }

                        subItem.querySelector('ul').innerHTML = childrenCode;

                        code += subItem.innerHTML;
                    }
                }

                this.target.outerHTML = code;
            }
        });
    },

    populate(string, item) {
        return string
            .replace('{ link_handle }', item.link_handle)
            .replace('{ link_url }', item.link_url)
            .replace('{ link_title }', item.link_title);
    },

    async getData() {
        const response = await fetch(`/pages/navigation?view=navigation`);
            
        response.ok;     // => false
        response.status; // => 404
        return await response.json();
    }
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.mobile_nav').addEventListener('click', function () {
        navigation.init();
    });
});